<template>
  <base-auth>
    <div class="alert alert-danger" v-if="rateLimitMessage">
      <small v-if="rateLimitCountdown > 0">
        {{ $t('auth.error.wait_time') }} 
        <span class="rate-limit-countdown">{{ rateLimitCountdown }}</span> 
        {{ $t('auth.error.seconds') }}
      </small>
    </div>
    <div
      v-if="alertMessage"
      :class="['alert', alertType === 'success' ? 'alert-success' : 'alert-danger']"
    >
      {{ alertMessage }}
    </div>

    <div class="kt-login__form">
      <form @submit.prevent="onSubmitVerify" class="kt-form">
        <vue-recaptcha
          v-if="captchaDriver === 'recaptcha'"
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          :sitekey="sitekey"
          :loadRecaptchaScript="true"
        />

        <arcaptcha-vue
          v-if="captchaDriver === 'arcaptcha'"
          ref="arcaptcha"
          :site_key="arCaptchaKey"
          :invisible="true"
          :callback="onArcaptchaSuccess"
          :expired_callback="onArcaptchaExpired"
          :error_callback="onArcaptchaError"
        />

        <kt-form-control
          :placeholder="$t('auth.placeholder.phone')"
          name="phone"
          id="phone"
          v-model="form_data.phone"
          :disabled="sent"
        />

        <div v-if="!sent" class="mt-5 text-center">
          <button
            class="btn btn-brand btn-pill btn-elevate"
            @click="sendVerify"
            :disabled="isRateLimited"
          >
            {{ isRateLimited ? `لطفا ${rateLimitCountdown} ثانیه دیگر تلاش کنید` : $t('btn.send_code') }}
          </button>
        </div>

        <div v-if="sent">
          <kt-form-group>
            <kt-form-control
              :placeholder="$t('auth.placeholder.code')"
              name="code"
              v-model="code"
            />
          </kt-form-group>
          <div class="kt-login__actions">
            <kt-button
              type="submit"
              id="verify_submit"
              variant="brand"
              class="btn-pill btn-elevate"
              :disabled="isRateLimited"
            >
              {{ isRateLimited ? `لطفا ${rateLimitCountdown} ثانیه دیگر تلاش کنید` : $t('auth.btn.verify') }}
            </kt-button>
          </div>
        </div>
      </form>
    </div>

    <div class="kt-login__account" v-if="sent">
      <span class="kt-login__account-msg">
        {{ $t('auth.not_recived') }}
      </span>
      &nbsp;&nbsp;
      <button 
        class="btn btn-link p-0 m-0" 
        @click="sendVerify"
        :disabled="isRateLimited"
      >
        {{ isRateLimited ? `لطفا ${rateLimitCountdown} ثانیه دیگر تلاش کنید` : $t('auth.btn.resend') }}
      </button>
    </div>
  </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { mapGetters, mapState, mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import ArcaptchaVue from 'arcaptcha-vue'

export default {
  data() {
    return {
      code: '',
      recaptcha_verified: false,
      g_recaptcha_response: '',
      sitekey: reCaptchaKeys,
      arCaptchaKey: arCaptchaKeys,
      captchaDriver: getCaptchaDriver,
      arcaptchaToken: '',
      arcaptchaVerified: false,
      login_event: null,
      isRateLimited: false,
      rateLimitMessage: '',
      rateLimitCountdown: 0,
      rateLimitInterval: null,
      alertMessage: '',
      alertType: '',
    }
  },
  computed: {
    ...mapState('auth', ['sent']),
    ...mapGetters('auth', ['form_data']),
    ...mapActions('auth', ['sendVerifyStatus']),
  },
  components: {
    'base-auth': baseAuth,
    'vue-recaptcha': VueRecaptcha,
    ArcaptchaVue,
  },
  methods: {
    onSubmitVerify(e) {
      if (this.isRateLimited) return
      this.executeCaptcha()
      this.login_event = e
    },
    executeCaptcha() {
      if (this.captchaDriver === 'recaptcha') {
        this.$refs.invisibleRecaptcha.execute()
      } else {
        this.arcaptchaVerified = false
        this.arcaptchaToken = ''
        this.$refs.arcaptcha.execute()
      }
    },
    onVerify(response) {
      this.recaptcha_verified = true
      this.g_recaptcha_response = response
      this.verify(this.login_event)
    },
    onArcaptchaSuccess(token) {
      this.arcaptchaToken = token
      this.arcaptchaVerified = true
      this.verify(this.login_event)
    },
    onArcaptchaExpired() {
      this.arcaptchaVerified = false
      this.arcaptchaToken = ''
    },
    onArcaptchaError() {
      this.arcaptchaVerified = false
      this.arcaptchaToken = ''
      this.showMsg('danger', this.$t('auth.error.captcha_failed'))
    },
    onExpired() {
      this.recaptcha_verified = false
    },

    sendVerify(e) {
      if (this.isRateLimited) return

      const btn = $(e.target)
      const form = $('.kt-form')
      const phone = $('#phone')

      const params = { phone: phone.val() }

      KTApp.progress(btn)
      this.$store
        .dispatch('auth/sendVerifyRegister', params)
        .then((response) => {
          this.showMsg('success', response.message)
          this.sendVerifyStatus
        })
        .catch((response) => {
          if (response.status === 429) {
            const remainingSeconds = (response.data.data && response.data.data.remaining_seconds) ? response.data.data.remaining_seconds : 60;
            
            this.showRateLimitError(remainingSeconds);
            this.startRateLimitCountdown(remainingSeconds);
          } else if (response.data && response.data.errors) {
            form.validate().showErrors(response.data.errors)
          } else {
            this.showMsg('danger', response.message || this.$t('auth.error.general'))
          }
        })
        .finally(() => {
          KTApp.unprogress(btn)
        })
    },

    verify(e) {
      if (this.isRateLimited) return

      const form = $(e.target)
      const btn = $('#verify_submit')
      const phone = $('#phone')

      form.validate({
        rules: { code: { required: true }, phone: { required: true } },
      })
      if (!form.valid()) return

      const params = {
        code: this.code,
        phone: phone.val(),
        'g-recaptcha-response':
          this.captchaDriver === 'recaptcha'
            ? this.g_recaptcha_response
            : this.arcaptchaToken,
      }

      KTApp.progress(btn)
      this.$store
        .dispatch('auth/verifyRegister', params)
        .then(() => {
          this.showMsg('success', this.$t('auth.success.verified'))
          window.location.replace(this.$url(''))
        })
        .catch((response) => {
          if (response.status === 429) {
            this.showRateLimitError(
              response.data.data.remaining_seconds
            )
          } else if (response.data && response.data.errors) {
            form.validate().showErrors(response.data.errors)
          } else {
            this.showMsg('danger', response.message || this.$t('auth.error.general'))
          }
        })
        .finally(() => {
          KTApp.unprogress(btn)
        })
    },

    showRateLimitError(remainingSeconds) {
      this.isRateLimited = true
      this.rateLimitMessage = 'Rate limit exceeded'
      this.rateLimitCountdown = remainingSeconds
    },
    
    hideRateLimitError() {
      this.isRateLimited = false
      this.rateLimitMessage = ''
      this.rateLimitCountdown = 0
    },
    
    startRateLimitCountdown(seconds) {
      if (this.rateLimitInterval) clearInterval(this.rateLimitInterval)

      this.rateLimitCountdown = seconds
      this.rateLimitInterval = setInterval(() => {
        this.rateLimitCountdown--
        if (this.rateLimitCountdown <= 0) {
          clearInterval(this.rateLimitInterval)
          this.hideRateLimitError()
        }
      }, 1000)
    },

    showMsg(type, message) {
      if (type === 'danger' && message.includes('rate limit')) {
        return;
      }
      
      this.alertType = type
      this.alertMessage = message
      setTimeout(() => {
        this.alertMessage = ''
      }, 5000)
    },
  },
  
  beforeDestroy() {
    if (this.rateLimitInterval) {
      clearInterval(this.rateLimitInterval)
    }
  },
}
</script>

<style scoped>
.btn.btn-link:hover,
.btn.btn-link:focus {
  background-color: inherit !important;
  color: inherit !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>